import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import Toolbar from '@material-ui/core/Toolbar';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';

import Pause from '@material-ui/icons/Pause';
import PlayArrowIcon from '@material-ui/icons/PlayArrowSharp';
import ShuffleIcon from '@material-ui/icons/ShuffleSharp';
import SkipNextIcon from '@material-ui/icons/SkipNextSharp';
import StopIcon from '@material-ui/icons/StopSharp';

import Slider from '@material-ui/lab/Slider';

import * as React from 'react';
import { GameState } from '../common/life';
import { LifeEvents, Messages } from '../store/life';
import Spacer from './Spacer';


interface NavBarProps {
  events: LifeEvents,
  game: GameState,
}

export const NavBar = (props: NavBarProps) => {
  const dispatch = props.events.dispatch();

  const handleChange = (event: any, value: number) => {
    dispatch(Messages.setEvolveRate(value));
  };

  return (
    <AppBar position="static" color="default">
      <Toolbar>
        <Typography variant="display1" color="inherit" className="grow">
          Life
        </Typography>

        <Spacer />

        <Tooltip title="Number of evolution cycles completed">
          <TextField
            InputProps={{ readOnly: true }} fullWidth={true}
            label="Year" value={props.game.year} />
        </Tooltip>

        <Spacer />

        <Tooltip title="Current number of live cells">
          <TextField InputProps={{ readOnly: true }} fullWidth={true}
            label="Population" value={props.game.population.count} />
        </Tooltip>

        <Spacer />

        <Tooltip title="Play / Pause">
          <IconButton
            aria-label="Play / Pause"
            onClick={props.events.toggleLife}>
            { props.game.suspended
              ? <PlayArrowIcon color="primary" />
              : <Pause color="primary" /> }
          </IconButton>
        </Tooltip>

        <Tooltip title="Step Forward">
          <IconButton
            aria-label="Step Forward" onClick={props.events.evolveForce}>
            <SkipNextIcon color="primary" />
          </IconButton>
        </Tooltip>

        <Tooltip title="Stop">
          <IconButton color="primary"
            aria-label="Stop" onClick={props.events.resetClear}>
            <StopIcon />
          </IconButton>
        </Tooltip>

        <Tooltip title="Shuffle">
          <IconButton color="primary"
            aria-label="Shuffle" onClick={props.events.resetRandomized}>
            <ShuffleIcon />
          </IconButton>
        </Tooltip>

        <Spacer />

        <Typography variant="button" color="inherit" className="grow">
          Rate
        </Typography>
        <Tooltip title={props.game.rate + " ms"}>
          <Slider min={10} max={1000} step={50}
            onChange={handleChange} value={props.game.rate} />
        </Tooltip>

      </Toolbar>
    </AppBar>
  );

};

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/NavBar.tsx